export default __webpack_public_path__ + "static/checkflat-ec62a00b65230273a320a5323cf8822d.png";